import { render } from "./Navbar.vue?vue&type=template&id=19bc8972&scoped=true&ts=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=19bc8972&scoped=true&lang=css"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-ce2d8e187f/2/root/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bc8972"]])

export default __exports__